import {defineMessages} from 'react-intl';

export const UrgencyMessages = defineMessages({
  ticketsAtMinPrice: {
    id: 'Event.Urgency.TicketsAtMinPrice',
    defaultMessage: 'Only {ticketsAtMinPrice, plural, one {1 ticket} other {# tickets}} left at lowest price',
    description: 'The Event List Urgency Message for TicketsAtMinPrice',
  },
  totalViews: {
    id: 'Event.Urgency.TotalViews',
    defaultMessage: '{totalViews, plural, one {1 person is} other {# people are}} viewing this event',
    description: 'The Event List Urgency Message for TotalViews',
  },
  ticketsLeft: {
    id: 'Event.Urgency.ticketsLeft',
    defaultMessage:
      '{ticketsLeft, plural, =0 {We have no tickets available. Come back later} one {# ticket left on our site} other {# tickets left on our site}}',
    description: 'The Event List Urgency Message for TicketsLeft',
  },
  sellingFast: {
    id: 'Event.Urgency.sellingFast',
    defaultMessage: 'Selling Fast!',
    description: 'The Event List Urgency Message for SellingFast',
  },
  hotEvent: {
    id: 'Event.Urgency.HotEvent',
    description: 'The Event List Urgency Message for HotEvent',
    defaultMessage: 'Top event',
  },
});
